import type { ResourceId } from "@@/shared/acquire/resources/resource-id";
import type { ResourceReservationId } from "@@/shared/acquire/resources/resource-reservation-id";
import type { ProviderId } from "@@/shared/providers/provider-id";
import type { CheckIn_CheckedInEvent } from "@@/shared/statuses/reservation-check-ins/events/check-in.checked-in.event";
import type {
    ResourceCheckInStatusProjection} from "@@/shared/statuses/reservation-check-ins/resource-check-in.status-projection";
import {
    initialResourceCheckInStatusProjectionFactory,
} from "@@/shared/statuses/reservation-check-ins/resource-check-in.status-projection";
import type { StatusEvent } from "@@/shared/statuses/status-event";

function resourceCheckInStatusProjectionReducer(params: {
    events: StatusEvent[];
    currentProjection: ResourceCheckInStatusProjection | undefined;
    resourceId: ResourceId;
    providerId: ProviderId;
}) {
    const { events, resourceId, providerId } = params;
    const eventsFiltered = events.filter(
        event =>
            event.references.resourceId === resourceId &&
            event.references.providerId === providerId,
    );

    // Initial projection
    const projection: ResourceCheckInStatusProjection =
        params.currentProjection ??
        initialResourceCheckInStatusProjectionFactory({
            resourceId,
            providerId,
        });

    // If no events return the  empty initial projection
    if (!eventsFiltered.length) {
        return projection;
    }

    // If there are events, up the version of the the projection...
    projection._version += 1;

    // and process the events:
    const checkedIn: Map<ResourceReservationId, CheckIn_CheckedInEvent> =
        new Map();

    for (const event of eventsFiltered) {
        const resourceReservationId = event.references.resourceReservationId;
        const providerId = event.references.providerId;
        if (!resourceReservationId || !providerId) continue;
        if (event.type === "CHECK_IN__CHECKED_IN") {
            checkedIn.set(resourceReservationId, event);
        } else if (event.type === "CHECK_IN__CHECKED_OUT") {
            checkedIn.delete(resourceReservationId);
        }
    }

    const checkIns = Array.from(checkedIn.values());
    projection.currentCheckIns = checkIns;
    projection.count = checkIns.length;
    return projection;
}
export { resourceCheckInStatusProjectionReducer };
